module.exports = __webpack_public_path__ + "static/img/hb_51-min.8817fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_51-min.png
// module id = x/IY
// module chunks = 1